import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SendVmiBinPdfApiParameter } from "@insite/client-framework/Services/VmiBinsService";

const vmiLocationBinsUrl = "api/v2/vmiLocations/{vmiLocationId}/bins";

export async function customSendPdf(parameter: SendVmiBinPdfApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await post(
            `${vmiLocationBinsUrl.replace("{vmiLocationId}", parameter.vmiLocationId ?? "")}/send-pdf`,
            parameter,
        );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}